import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  UncontrolledTooltip,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import DeleteModel from "common/deleteModel/deleteModel"

import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { Feedback_For, GetObjectsByFeedbackForValues } from "_mock/Static_data"
import FeedbackQuestionTable from "./FeedBackQuestionTable"

function FeedbackQuestion() {
  document.title = `Feedback Question | ${localStorage.getItem("ShopName")}`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()

  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [feedbackFor, setFeedbackFor] = useState(1)

  // Feedback Question list api
  const feedBackQuestionList = () => {
    setIsLoading(true)
    getApi("FeedBack/list", "").then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  // FeedBack Question api useEffect
  useEffect(() => {
    feedBackQuestionList()
  }, [])

  // Delete FeedBack Question handler
  const handleDelete = id => {
    setScreenLoad(true)
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure? ",
      text: "You want to delete this feedBack question permanently? ",
      isMobile,
    }).then(response => {
      if (response == true) {
        deleteApi(`FeedBack/delete?id=${id}`).then(({ data, status }) => {
          if (status === 200) {
            const updatedArray = tableData
              .map(obj => (obj.Id !== id ? obj : null))
              .filter(Boolean)
            setTableData(updatedArray)
            toast.success("Sucessfully deleted", {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            ErrorModel.errormodel({
              title: "Verify Feedback Question",
              text: data,
            })
          }
          setScreenLoad(false)
        })
      }
      setScreenLoad(false)
    })
  }

  // cancel handle
  const handleCancle = () => {
    toggle()
  }

  // Update FeedBack Question handler
  const handlEditFeedBackQuestion = editdata => {
    if (editdata) {
      setIsEdit(true)
      setModal(!modal)
      setEditData(editdata)
    }
  }

  // Create FeedBack Question handler
  const handleFeedBackQuestion = () => {
    setIsEdit(false)
    toggle()
  }

  // FeedBack Question Validations
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: isEdit ? editData.Id : "",
      Question: isEdit ? editData.Question : "",
      GroupType: isEdit ? editData.GroupType : 1,
    },
    validationSchema: Yup.object({
      Question: Yup.string().required("The question is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      const { Question, id, GroupType } = values
      isEdit
        ? putApi("FeedBack/update", {
          id: id,
          Question: Question,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status === 200) {
            feedBackQuestionList()
            toggle()
            validation.handleReset()
            setIsEdit(false)
            toast.success("Sucessfully updated", {
              style: {
                fontSize: "15px",
              },
            })
          } else {
            toggle()
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
            setIsEdit(false)
            validation.handleReset()
          }
        })
        : postApi("FeedBack/question-create", {
          Question: Question,
          GroupType: parseInt(GroupType),
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status === 200) {
            feedBackQuestionList()
            toggle()
            validation.handleReset()
            toast.success("Sucessfully created", {
              style: {
                fontSize: "15px",
              },
            })
            toggle()
            validation.handleReset()
          } else {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          }
        })
    },
  })

  // popup box handler
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  const handleSwitch = (id, IsActive, e) => {
    if (id) {
      putApi("Feedback/active-inactive", { id: String(id) }).then(({ data, status }) => {
        e.preventDefault()
        if (status === 200) {
          toast.success("Question sucessfully changed", {
            style: {
              fontSize: "15px",
            },
          })
        } else {
          $("#IsActive_" + id + "").prop("checked", IsActive)
          ErrorModel.errormodel({
            title: "Verify Question",
            text: data,
          })
        }
      })
    }
  }


  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Question",
        accessor: "Question",
      },
      {
        Header: "Group Type",
        accessor: "GroupType",
        width: "10%",
        Cell: ({ row }) => {
          const GroupType = GetObjectsByFeedbackForValues(row.original.GroupType);
          return <div>{GroupType[0]?.DisplayName}</div>
        },
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Is Active
          </div>
        ),
        width: "7%",
        accessor: "IsActive",

        Cell: ({ row }) => (
          <FormGroup switch className="d-flex justify-content-center">
            <Input
              type="switch"
              id={`IsActive_${row.original.Id}`}
              defaultChecked={row.original.IsActive}
              onClick={e => {
                handleSwitch(row.original.Id, row.original.IsActive, e)
              }}
            />
          </FormGroup>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        accessor: "action",
        width: "7%",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handlEditFeedBackQuestion(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  className="fs-6 fas fa-trash-alt btn-delete"
                  id={`deletetooltip${row.original.Id}`}
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delele</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <FeedbackQuestionTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isFeedBackQuestionList={true}
              handleFeedBackQuestion={handleFeedBackQuestion}
              customPageSize={10}
              isLoading={isLoading}
              className="custom-header-css"
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: "350px" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update Feedback Question" : "Create Feedback Question"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <FormGroup className="mb-2">
                      <Label htmlFor="validationCustom03" className="required">
                        Question
                      </Label>
                      <Input
                        name="Question"
                        placeholder="Feedback Question"
                        type="text"
                        className="form-control-sm"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.Question || ""}
                        invalid={
                          validation.touched.Question && validation.errors.Question
                            ? true
                            : false
                        }
                      />
                      {validation.touched.Question && validation.errors.Question ? (
                        <FormFeedback type="invalid">
                          {validation.errors.Question}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>

                    <FormGroup className="mb-2">
                      <Label htmlFor="validationCustom03" className="required">
                        Group Type
                      </Label>
                      <Input
                        type="select"
                        bsSize="sm"
                        id="validationCustom01"
                        className="form-control-sm"
                        name="GroupType"
                        disabled={isEdit}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.GroupType}
                        invalid={
                          validation.touched.GroupType && validation.errors.GroupType
                            ? true
                            : false
                        }
                      >
                        {Feedback_For?.map((item, index) => {
                          return (
                            <option key={index} className="bg-light text-dark" value={item.Value}>
                              {item.DisplayName}
                            </option>
                          )
                        })}
                      </Input>
                    </FormGroup>

                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      <>
                        {formSumitLoading ? (
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                          >
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                            Loading
                          </button>
                        ) : (
                          <Button
                            color="primary"
                            className="btn btn-primary btn-sm "
                            type="submit"
                          >
                            Submit
                          </Button>
                        )}
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
FeedbackQuestion.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default FeedbackQuestion
